export default "__VITE_ASSET__DQ_W1OL9__"